
import CommonButton from '~/components/common/button/CommonButton.vue'

export default {
  name: 'AvailableMassOrder',
  components: {
    CommonButton
  },
  layout: '',
  props: {
    usePossible: {
      type: Boolean,
      default: false,
    },
    purchaseValue: { // 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
    addrInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {}
  },
  methods: {
  }
}
